module.exports = __webpack_public_path__ + "img/20190524164527QQ截图20190524163236.f58adff2.png";